import React from "react";
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import FileIcon from 'react-feather/dist/icons/download-cloud';
class SongList extends React.Component {


  render() {
    const data = [
      { id: 1, title: "Come You Thirsty (Lead Sheet - Bb)", leadSheet: "/songs/1.pdf" },
      { id: 2, title: "Come You Thirsty (Lead Sheet - C)", leadSheet: "/songs/2.pdf" },
      { id: 3, title: "Hail the king (Lead Sheet)", leadSheet: "/songs/3.pdf" },
      { id: 4, title: "Let There Be Love (Lead Sheet)", leadSheet: "/songs/4.pdf" },
      { id: 5, title: "Merciful God (Lead Sheet)", leadSheet: "/songs/5.pdf" },
      { id: 6, title: "Praise to the Lord (Chord chart)", guitar: "/songs/6.pdf" },
      { id: 7, title: "Praise to the Lord (Harmonies)", piano: "/songs/7.pdf" },
      { id: 8, title: "Praise to the Lord (Lead Sheet)", leadSheet: "/songs/8.pdf" },
      { id: 9, title: "Waiting for the Day (Lead Sheet)", leadSheet: "/songs/9.pdf" }
    ];

    const columns = [
      { Header: 'Song', accessor: 'title' },
      {
        Header: 'Lead Sheet',
        accessor: 'leadSheet',
        Cell: props => {

          return (
            <div style={{ textAlign: "center" }}>
              {props.value && <a href={props.value} target="_blank">
                <FileIcon />
              </a>}
            </div>
          );
        }
      },
      {
        Header: 'Piano Score', accessor: 'piano',
        Cell: props => {

          return (
            <div style={{ textAlign: "center" }}>
              {props.value && <a href={props.value} target="_blank">
                <FileIcon />
              </a>}
            </div>
          );
        }
      },
      {
        Header: 'Guitar Score', accessor: 'guitar',
        Cell: props => {

          return (
            <div style={{ textAlign: "center" }}>
              {props.value && <a href={props.value} target="_blank">
                <FileIcon />
              </a>}
            </div>
          );
        }
      },
    ];
    return (
      <div style={{ overflowX: 'auto' }}>
        <ReactTable
          data={data}
          columns={columns}
          showPagination={false}
          defaultPageSize={9}
        />
      </div>
    );
  }
}

export default SongList;
